module.exports = __webpack_public_path__ + "static/media/sword.5b28b613.svg";